import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getPositions } from 'api';
import {
  getAreas,
  getDefectReasons,
  getMailingTypes,
  getMailReceiverAvailableColumns,
  getMailReceiverPositionAvailableColumns,
  getRealEstatesShort,
  getServiceOrgs,
} from './api';

export const path = '/mailing/list';

const PageMailingList: React.FC = (props) => {
  const MailingList = Loadable.Map({
    loader: {
      page: () => import('./page'),
      positions: getPositions,
      mailingTypes: getMailingTypes,
      serviceOrgs: getServiceOrgs,
      areas: getAreas,
      realEstates: getRealEstatesShort,
      defectReasons: getDefectReasons,
      receiverColumns: getMailReceiverAvailableColumns,
      receiverPositionColumns: getMailReceiverPositionAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <MailingList {...props} />;
};

export default PageMailingList;
